module.exports = __webpack_public_path__ + "static/voteforpolicies-c2f3233f44241dc4e917a47afcbdda62.svg";